<template>
  <div class="navbar-container main-menu-content">
    <horizontal-nav-menu-items :items="navMenuItems" />
  </div>
</template>

<script>
// import navMenuItems from '@/navigation/horizontal'
import { onMounted, ref } from '@vue/composition-api'
import store from '@/store'
import HorizontalNavMenuItems from './components/horizontal-nav-menu-items/HorizontalNavMenuItems.vue'
import { isUserLoggedIn } from '@/auth/utils'

export default {
  components: {
    HorizontalNavMenuItems,
  },
  setup() {
    const navMenuItems = ref([])
    onMounted(async () => {
      if (isUserLoggedIn()) {
        await store.dispatch('layout/getNavMenuItems')
        navMenuItems.value = store.getters['layout/navMenuItems']
      }
    })
    return {
      navMenuItems,
    }
  },
}
</script>

<style lang="scss">
@import "~@core/scss/base/core/menu/menu-types/horizontal-menu.scss";
</style>
